export const enum EVENTS {
  /** EVO 本地保存观看进度 */
  EVO_AUTOPLAYEND = 'EVO_AUTOPLAYEND',
  /** 跳转miniPay */
  MINIPAYMODAL = 'MINIPAYMODAL',
  /** 关闭面板 */
  SHOW_PANEL = 'SHOW_PANEL',
}
